// src/components/Sidebar.jsx
export default function Sidebar({ user, activePage, onNavigate, onLogout }) {
  const initials = (name) =>
    (name || 'U').trim().split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

  const nav = [
    {
      section: 'Visão geral',
      items: [
        { id: 'dashboard', label: 'Dashboard', icon: <svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg> },
        { id: 'faturas',   label: 'Faturas',   icon: <svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14,2 14,8 20,8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg> },
      ]
    },
    {
      section: 'Lançamentos',
      items: [
        { id: 'novo',      label: 'Novo lançamento', icon: <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg> },
        { id: 'historico', label: 'Histórico',        icon: <svg viewBox="0 0 24 24"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg> },
      ]
    },
    {
      section: 'Configurações',
      items: [
        { id: 'cartoes', label: 'Cartões', icon: <svg viewBox="0 0 24 24"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg> },
      ]
    }
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div className="sidebar-logo-mark">
          <div className="sidebar-logo-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 2L2 7l10 5 10-5-10-5z"/>
              <path d="M2 17l10 5 10-5"/>
              <path d="M2 12l10 5 10-5"/>
            </svg>
          </div>
          <span className="sidebar-logo-text">Finanças</span>
        </div>
      </div>

      <div className="sidebar-user">
        <div className="user-avatar">{initials(user?.displayName)}</div>
        <div className="user-name">{user?.displayName || user?.email}</div>
        <button className="btn-logout" onClick={onLogout} title="Sair">
          <svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </button>
      </div>

      {nav.map(({ section, items }) => (
        <div key={section}>
          <div className="nav-section-label">{section}</div>
          {items.map(({ id, label, icon }) => (
            <div
              key={id}
              className={`nav-item${activePage === id ? ' active' : ''}`}
              onClick={() => onNavigate(id)}
            >
              {icon}
              {label}
            </div>
          ))}
        </div>
      ))}
    </aside>
  );
}
